import { createApp } from "vue";
import { setApp } from "./app-management";
import { defineGlobalDirectives } from "../directives/global-directives";
import Root from "@/vue/root.vue";

export default {
    init(){
        const app = setApp(createApp(Root));
        defineGlobalDirectives();
        app?.mount('#root');
    }
}